/* Bourgeois jerky redesign - cart cross sell behaviour
   Ariel Creative Group, 10 August 2026.

   TWO TRAPS, both found by watching it fail rather than by reading docs.

   TRAP 1: scripts injected with innerHTML never execute.
   theme.js fetches the cart ajax template and writes it into the drawer with
   innerHTML, so the inline script inside snippets/jerky-cross-sell.liquid
   never runs there, on any redraw, ever. Delegation on document survives any
   number of innerHTML replacements, so nothing needs binding.

   TRAP 2: a form inside a form.
   Impulse wraps the whole drawer, and the cart page, in one form with
   id CartDrawerForm and action /cart. The cross sell rows used to be forms
   too, so injecting them created nested forms. That is invalid HTML and the
   browser does not complain: it resolves the Add button to the OUTER form.
   Clicking Add submitted the cart form and navigated to /cart. No error, no
   console message, nothing added, and no submit event for any handler to see.

   So the snippet now takes nested: true, renders each row as a div with a
   type=button Add, and this file listens for CLICKS. Clicks do not care about
   form ownership.

   WHO HANDLES WHAT
     div[data-jky-xform]    always this file. Nested rows, no form semantics.
     form[data-jky-xform]   the snippet's inline script, which stamps each one
                            data-jky-bound. This file ignores those, so a
                            single click never fires two fetches.

   REDRAW IS IMPULSE'S JOB. theme.js contains, verbatim:
     document.addEventListener("cart:build", function () { this.buildCart() })
   so dispatching cart:build makes it refetch and repaint the drawer, cross
   sell included. Read out of the compiled theme.js. Do not hand roll a redraw. */

(function () {
  'use strict';

  var HOST = '[data-jky-xform]';

  function clamp(n) {
    n = parseInt(n, 10);
    if (isNaN(n) || n < 1) { return 1; }
    if (n > 99) { return 99; }
    return n;
  }

  // A div row is always ours. A form row is ours only if the inline script
  // never reached it, which in practice means it was injected after load.
  function ours(host) {
    if (!host) { return false; }
    if (host.tagName === 'DIV') { return true; }
    return !host.getAttribute('data-jky-bound');
  }

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  function label(btn) {
    return (btn && btn.getAttribute('data-jky-label')) || 'Add';
  }

  function reset(btn) {
    if (!btn) { return; }
    btn.disabled = false;
    btn.textContent = label(btn);
    btn.classList.remove('is-added');
  }

  document.addEventListener('click', function (e) {
    var step = closest(e.target, '[data-jky-xstep]');
    if (step) {
      var stepHost = closest(step, HOST);
      if (!ours(stepHost)) { return; }
      var q = stepHost.querySelector('[data-jky-xqty]');
      if (!q) { return; }
      q.value = clamp(clamp(q.value) + parseInt(step.getAttribute('data-jky-xstep'), 10));
      reset(stepHost.querySelector('[data-jky-xbtn]'));
      return;
    }

    var btn = closest(e.target, '[data-jky-xbtn]');
    if (!btn) { return; }
    var host = closest(btn, HOST);
    if (!ours(host)) { return; }

    // Stops the outer cart form from submitting, whatever the button type.
    e.preventDefault();
    if (!window.fetch) { return; }

    var qty = host.querySelector('[data-jky-xqty]');
    if (qty) { qty.value = clamp(qty.value); }

    var body = new FormData();
    var fields = host.querySelectorAll('input[name]');
    for (var i = 0; i < fields.length; i++) {
      body.append(fields[i].name, fields[i].value);
    }

    btn.disabled = true;
    btn.textContent = 'Adding';

    fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) { throw new Error('add failed'); } return r.json(); })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function () {
        // Nothing to fall back to inside a nested row, so say so rather than
        // leaving a dead button.
        btn.disabled = false;
        btn.textContent = 'Try again';
        window.setTimeout(function () { reset(btn); }, 2500);
      });
  });

  document.addEventListener('change', function (e) {
    var qty = closest(e.target, '[data-jky-xqty]');
    if (!qty || !ours(closest(qty, HOST))) { return; }
    qty.value = clamp(qty.value);
  });

  // A number input steps on scroll while focused, which silently changes an
  // order. Take focus away instead.
  document.addEventListener('wheel', function (e) {
    var qty = closest(e.target, '[data-jky-xqty]');
    if (qty && ours(closest(qty, HOST))) { qty.blur(); }
  }, { passive: true });
})();
